// Phase 2 — Password reset (forgot-password) stage extracted from Login.jsx.
// Asks for the user's email and pings /auth/forgot-password. Parent owns
// the submit handler + email state.

import { ArrowLeft, Loader2, Mail } from "lucide-react";
import { Field, inputCls, primaryBtn } from "./LoginShared";

export default function PasswordReset({
  email, setEmail,
  busy,
  onSubmit,
  onBack,
}) {
  return (
    <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-form">
      <p className="text-[13px] text-[var(--muted)] leading-relaxed">
        Enter your email and we'll send a reset link valid for 1 hour.
      </p>
      <Field label="Email" icon={Mail}>
        <input
          data-testid="forgot-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={inputCls}
          autoFocus
        />
      </Field>
      <button type="submit" disabled={busy} data-testid="forgot-submit" className={primaryBtn}>
        {busy && <Loader2 size={14} className="animate-spin" />}
        Send reset link
      </button>
      <button
        type="button"
        onClick={onBack}
        className="w-full text-center text-[12px] text-[var(--muted)] hover:text-[var(--ink)] transition-colors inline-flex items-center justify-center gap-1.5"
      >
        <ArrowLeft size={11} /> Back to sign in
      </button>
    </form>
  );
}
